import { create } from "zustand";
import {
  createMarketplaceAllowancePolicySlice,
  marketplaceAllowancePolicyInitialState,
  resetMarketplaceAllowancePolicyRequests,
} from "./allowancePolicySlice";
import {
  createMarketplaceCatalogSlice,
  marketplaceCatalogInitialState,
  resetMarketplaceCatalogRequests,
} from "./catalogSlice";
import {
  createMarketplaceOverviewSlice,
  marketplaceOverviewInitialState,
  resetMarketplaceOverviewRequests,
} from "./overviewSlice";
import { refreshLoadedMarketplaceAdministration } from "./refresh";
import { createMarketplaceOpportunityInventorySlice, marketplaceOpportunityInventoryInitialState, resetMarketplaceOpportunityInventoryRequests } from "./opportunityInventorySlice";
import { createMarketplaceOpportunityDetailSlice, marketplaceOpportunityDetailInitialState, resetMarketplaceOpportunityDetailRequests } from "./opportunityDetailSlice";
import type { MarketplaceAdministrationState } from "./types";
import { createMarketplaceProductActivitySlice, marketplaceProductActivityInitialState, resetMarketplaceProductActivityRequests } from "./productActivitySlice";
import { createMarketplacePricingSalesSlice, marketplacePricingSalesInitialState, resetMarketplacePricingSalesRequests } from "./pricingSalesSlice";

const initialState = {
  ...marketplaceOverviewInitialState,
  ...marketplaceCatalogInitialState,
  ...marketplaceAllowancePolicyInitialState,
  ...marketplaceOpportunityInventoryInitialState,
  ...marketplaceOpportunityDetailInitialState,
  ...marketplaceProductActivityInitialState,
  ...marketplacePricingSalesInitialState,
};

export const useMarketplaceAdministrationStore = create<MarketplaceAdministrationState>(
  (set, get, store) => ({
    ...createMarketplaceOverviewSlice(set, get, store),
    ...createMarketplaceCatalogSlice(set, get, store),
    ...createMarketplaceAllowancePolicySlice(set, get, store),
    ...createMarketplaceOpportunityInventorySlice(set, get, store),
    ...createMarketplaceOpportunityDetailSlice(set, get, store),
    ...createMarketplaceProductActivitySlice(set, get, store),
    ...createMarketplacePricingSalesSlice(set, get, store),
    refreshLoaded: () => refreshLoadedMarketplaceAdministration(get()),
    reset: () => {
      resetMarketplaceOverviewRequests();
      resetMarketplaceCatalogRequests();
      resetMarketplaceAllowancePolicyRequests();
      resetMarketplaceOpportunityInventoryRequests();
      resetMarketplaceOpportunityDetailRequests();
      resetMarketplaceProductActivityRequests();
      resetMarketplacePricingSalesRequests();
      set(initialState);
    },
  }),
);
